module.exports = __webpack_public_path__ + "img/webopac_APP-02_03.89a7adee.jpg";